import { useEffect, useState } from 'react';
import { getSponsors } from '../../services/apiClient';
import type { Sponsor } from '../../types';
import { SPONSORSHIP_LEVEL_ORDER, SPONSORSHIP_LEVEL_LABELS } from '../../lib/constants';
import { EmptyState } from '../../components/ui/EmptyState';
import styles from './SponsorsPage.module.css';

export function SponsorsPage() {
  const [sponsors, setSponsors] = useState<Sponsor[]>([]);

  useEffect(() => {
    getSponsors().then((r) => r.data && setSponsors(r.data));
  }, []);

  const byLevel = SPONSORSHIP_LEVEL_ORDER.reduce<Record<string, Sponsor[]>>((acc, level) => {
    acc[level] = sponsors.filter((s) => s.sponsorship_level === level);
    return acc;
  }, {});

  const hasSponsors = sponsors.length > 0;

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className="container">
          <h1 className={styles.title}>Our Sponsors</h1>
          <p className={styles.sub}>We are grateful for the support of our community partners.</p>
        </div>
      </div>

      <div className="container">
        {!hasSponsors ? (
          <EmptyState title="No sponsors listed yet" />
        ) : (
          SPONSORSHIP_LEVEL_ORDER.map((level) => {
            const group = byLevel[level];
            if (!group || group.length === 0) return null;
            return (
              <div key={level} className={styles.levelGroup}>
                <h2 className={styles.levelTitle}>{SPONSORSHIP_LEVEL_LABELS[level]}</h2>
                <div className={[styles.grid, styles[level]].join(' ')}>
                  {group.map((sponsor) => (
                    <a
                      key={sponsor.id}
                      href={sponsor.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.sponsorCard}
                    >
                      {sponsor.logo_url ? (
                        <img src={sponsor.logo_url} alt={sponsor.name} className={styles.logo} />
                      ) : (
                        <span className={styles.sponsorName}>{sponsor.name}</span>
                      )}
                    </a>
                  ))}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
